<template>
  <div>
    <div  class="d-flex w-100 justify-content-between">
      <DebouncedSearch
        :placeholder="$t('global.search')"
        v-model="filters.search"
        @click="getData"
        size="sm"
        wrapper-class="flex-grow-1 mr-2" />
      <Pagination size="small" class="mr-2" :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
    </div>
    <b-list-group>
      <b-list-group-item v-for="item in items" :key="item.id"
        :class="['flex-column align-items-start py-1 px-2 has-default-router-link min-row', { empty: !!item.empty }]">
        <b-spinner small v-if="item.empty && loading" type="grow" variant="primary"/>
        <div v-if="!item.empty" class="d-flex w-100 justify-content-between">
          <span>
            <small class="idcol mr-2">{{ momentf(item.created_at) }}:</small>
            <span>{{ item.log_name }}/{{ item.description }}</span>
          </span>
          <div class="flex-container options-center">
            <small v-if="item.causer" class="mx-1">{{ item.causer.email }}</small>
            <b-link v-if="item.label_set_id"  class="mx-1 noline"
              :to="{ name: 'LabelSetSamples', params: { project_id: activeProjectId, label_set_id: item.label_set_id } }" >
              <i class="fa fa-object-group"/> {{ item.label_set_id }}
            </b-link>
            <b-link v-if="item.label_set_id && item.sample_id"  class="mx-1 noline"
              :to="{ name: 'LabelSample', params: { project_id: activeProjectId, sample_id: item.sample_id, label_set_id: item.label_set_id } }" >
              <i class="fa fa-picture-o"/> {{ item.sample_id }}
            </b-link>
            <span v-else-if="item.sample_id" class="mx-1"><i class="fa fa-picture-o"/>{{ item.sample_id }}</span>

            <!-- <router-link class="default-router-link" v-if="item.actions.update" :to="{ name: 'SampleSetUpload', params:{ project_id: item.project_id, id: item.id }}">
              <i class="mx-1 fa fa-upload fa-lg text-warning"/>
            </router-link>
            <router-link v-if="item.actions.view" :to="{ name: 'Samples', params:{ project_id: item.project_id, sample_set_id: item.id }}">
              <i class="mx-1 fa fa-eye fa-lg text-success"/>
            </router-link>
            <router-link v-if="item.actions.update" :to="{ name: 'SampleSetUpdate', params:{ project_id: item.project_id, id: item.id }}">
              <i class="mx-1 fa fa-edit fa-lg"/>
            </router-link> -->
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

    <!-- <div class="wrapper">
      <div class="animated fadeIn">
        <b-card>
          <div slot="header" class="d-flex justify-content-between">
            {{ $dt('audit_logs.audit_logs_list_title') }}
            <div v-if="listPaginator.last_page > 1" >
                <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" size="small" class="mb-0"/>
            </div>
          </div>
          <div v-if="loading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="12">
                <b-table class="table-sm text-center" responsive outlined hover head-variant="light"
                         :fields="tableFields" :items="tableItems"
                         @row-clicked="rowClicked"
                         >

                  <template v-slot:cell(causer)="{value}">
                    {{ value.full_name }} <b-badge>{{ value.email }}</b-badge>
                  </template>
                  <template v-slot:cell(created_at)="{value}">{{ momentf(value) }}</template>
                  <template v-slot:cell(label_set_id)="{item, value}">
                    <b-link v-if="value" :to="{ name: 'LabelSetSamples', params:{ project_id: activeProjectId, label_set_id: item.label_set_id  }}" >{{ value }}</b-link>
                  </template>
                  <template v-slot:cell(sample_id)="{item, value}">
                    <b-link v-if="item.label_set_id && item.sample_id"
                      :to="{ name: 'LabelSample', params:{ project_id: activeProjectId, sample_id: item.sample_id, label_set_id: item.label_set_id }}" >
                      {{ value }}
                    </b-link>
                    <span v-else-if="item.sample_id">{{ value }}</span>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" v-if="tableItems.length">
                <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" size="small"/>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div> -->

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';
import statuses from '@/store/statuses';
import 'vue-json-pretty/lib/styles.css';
import Services from '@/services/index';
import DebouncedSearch from '../Shared/DebouncedSearch.vue';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      loading: true,
      page: 1,
      rqi: 0,
      // tableFields: [
      //   { key: 'id', label: this.$t('global.id') },
      //   { key: 'log_name', label: this.$dt('audit_logs.log_name', 'Log Name') },
      //   { key: 'description', label: this.$t('global.description') },
      //   { key: 'label_set_id', label: this.$dt('audit_logs.label_set', 'Label Set') },
      //   { key: 'sample_id', label: this.$dt('audit_logs.label_set', 'Sample') },
      //   { key: 'causer', label: this.$dt('audit_logs.causer', 'User') },
      //   { key: 'created_at', label: this.$dt('audit_logs.created_at', 'When') },
      // ],
      list: {},
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 10,
      },
    };
  },
  props: {},
  components: {
    Pagination,
    DebouncedSearch
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    validItems() { return this.list.data || []; },
    items() {
      const emptyItemCount = this.filters.per_page - this.validItems.length;
      const emptyItems = [...Array(emptyItemCount)].map((_, idx) => ({ id: `empty${idx}`, empty: true }));
      return [...this.validItems, ...emptyItems] || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc',
        ...(this.user_id ? {
          causer_type: 'App\\Models\\User',
          causer_id: this.user_id,
        } : {})
      };
    },
  },
  watch: {
    page: 'getData',
    'filters.search'() { this.page = 1; },
    filters: { deep: true, handler: 'getData' },
    activeProjectId() {
      if (this.activeProjectId) {
        this.getData();
      } else {
        this.list = { data: [] };
      }
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.list = { data: [] };
      this.rqi++;
      const crqi = this.rqi;

      Services.auditLogs.list({ projectId: this.activeProjectId, params: this.params }).then(({ data }) => {
        if (this.rqi !== crqi) return;
        this.list = data;
        this.loading = false;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          console.log(err);
        }
      });
    },
    onPageChange(page) {
      this.page = page || this.page;
    },
  }
};

</script>

<style scoped lang="scss">
.has-default-router-link:hover .default-router-link {
  text-shadow: 0px 0px 4px $black;
}

.min-row {
  min-height: 2.22em;

  &.empty {
    background-color: $gray-200;
  }
}

.idcol {
  min-width: 30px;
  display: inline-block;
  text-align: right;
}

a.noline {
  text-decoration: none;
}
</style>
